import axios from 'axios';
import { LOCAL_HOST, X_FOWARD_HOST } from '../utils/env';

const api = axios.create({
	baseURL: LOCAL_HOST,
	withCredentials: true,
	headers: {
		'content-type': 'application/json',
		//'content-length': 89,
		'X-Forwarded-Host': X_FOWARD_HOST,
	
	},
});

api.interceptors.request.use(function (config) {
	const token = sessionStorage.getItem(
		`@${process.env.REACT_APP_ESTATE_ID}GESTAOUSERTOKEN`
	);

	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}

	return config;
});

/*
api.defaults.headers.Authorization= `Bearer ${sessionStorage.getItem(
	`@${process.env.REACT_APP_ESTATE_ID}GESTAOUSERTOKEN`
)}`
*/
export default api;
